(function() {
  window.unlockQueueService = {
    getQueue(config) {
      return axios.get('/api/unlock/get.php?queue=true',config);
    },
    getUserQueue(id){
      return axios.get('/api/unlock/get_current_user.php?packs=true&&twitchId='+id);
    },
    saveCurrenUserPack (id){
      return axios.post('/api/unlock/save_user_pack.php', id)
    },
    getReceived() {
      return axios.get('/api/unlock/get.php?received=true');
    },
    getActive() {
      return axios.get('/api/unlock/get.php?active=true');
    },
    getAuto() {
      return axios.get('/api/unlock/get.php?auto=true');
    },
    getUserActive(id){
      return axios.get('/api/unlock/get.php?unlockId='+id);
    },
    save(data) {
      return axios.post('/api/unlock/save.php', data)
    },
    cancel(data) {
      return axios.post('/api/unlock/cancel.php', data);
    },
    sendToHQ(data){
      return axios.post('/api/unlock/hq.php', data);
    },
    getPacksInfo(id){
      return axios.get('/api/user/unlock/get.php?twitchId='+id);
    }
  }
})();